import Swiper from "swiper/bundle";

const container = document.querySelectorAll(".testimonial-slider");

if (container) {
  container.forEach((el) => {
    const testimonial = el.querySelector(".testimonial-swiper");
    const nextEl = el.querySelector(".button-next");
    const prevEl = el.querySelector(".button-prev");
    const swiper = new Swiper(testimonial, {
      // Optional parameters
      A11y: true,
      loop: true,
      autoplay: {
        delay: 8000,
      },
      slidesPerView: 1,

      // Navigation arrows
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });
  });
}
